import React from 'react';

import styles from './RiskField.module.scss';
import { ConfirmationModal } from '../../modal/ConfirmationModal';
import { ModalHeader } from '../../modal/ModalHeader';

interface DeleteConfirmationModalProps {
    deleteExample: () => void;
    closeModal: () => void;
    icon: React.FC;
    children?: JSX.Element | null;
}

export const DeleteConfirmationModal: React.FC<DeleteConfirmationModalProps> = ({ deleteExample, closeModal, icon, children }) => (
    <ConfirmationModal
        isOpen
        closeModal={closeModal}
        confirmLabel='Delete'
        testId='delete-example'
        confirm={deleteExample}
        maxWidth={50}
    >
        <ModalHeader label='Delete Risk Example' icon={icon} testId='delete-risk-example-modal' />
        <div className={styles.deleteConfirmationWrapper} data-testid='delete-risk-example-modal-wrapper'>
            <div className={styles.warningTitle} data-testid='delete-risk-example-warning-title'>Are you sure you want to delete this example</div>
            {children}
        </div>
    </ConfirmationModal>
);
